import {
  Container
} from "@mui/material";
import React from "react";
import OurServices from "../component/pricing/OurServices";
import PricingPlan from "../component/pricing/PricingPlan";

const Pricing = () => {
  return (
    <Container maxWidth="lg">
      <OurServices/>
      <PricingPlan/>
    </Container>
  );
};

export default Pricing;
